import { system } from "styled-system"

export const strokeColor = system({
	strokeColor: {
		property: "stroke"
	},
	fillColor: {
		property: "fill"
	}
})
